<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de Trabajadores"
          icon="fas fa-coins"
          btn_name="Trabajador"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="true"
          :actions="true"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <cSelectForm
            v-if="this.$store.getters.get_all_user.id == 1"
            label="Empresa"
            placeholder="Seleccione empresa"
            :options="data_companies"
            :value.sync="employee.company_id"
          />
          <cSelectForm
            label="Rol"
            placeholder="Seleccione rol"
            :options="data_roles"
            :value.sync="employee.rol_id"
          />

          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="employee.name"
            @input="ValidateName"
          />
          <span v-if="errors.name" class="text-danger">{{ errors.name }}</span>
          <CInput
            v-if="modal.action === 'store'"
            label="Apellido"
            placeholder="Digite apellido"
            v-model="employee.last_name"
            @input="ValidateLastName"
          />
          <span v-if="errors.last_name" class="text-danger">{{
            errors.last_name
          }}</span>
          <CInput
            label="Dni"
            placeholder="Digite dni"
            v-model="employee.dni"
            maxlength="8"
            @input="validateDNI"
          />
          <span v-if="errors.dni" class="text-danger">{{ errors.dni }}</span>

          <CInput
            label="Dirección"
            placeholder="Digite dirección"
            v-model="employee.address"
          />
          <CInput
            label="Telefono"
            placeholder="Digite telefono"
            v-model="employee.phone"
            maxlength="9"
            @input="validatePhone"
          />
          <span v-if="errors.phone" class="text-danger">{{
            errors.phone
          }}</span>
          <CInput
            label="Correo"
            type="email"
            placeholder="Digite correo"
            v-model="employee.email"
            @input="validateEmail(employee.email)"
          />
          <span v-if="errors.email_employee" class="text-danger">{{
            errors.email_employee
          }}</span>
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="employee.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Rol'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "company_reason_social", label: "Empresa", _style: "width:20%;" },
  { key: "rol_name", label: "Rol", _style: "width:20%;" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "dni", label: "Dni", _style: "width:20%;" },
  { key: "address", label: "Dirección", _style: "width:20%;" },
  { key: "phone", label: "Telefono", _style: "width:20%;" },
  { key: "email", label: "Correo", _style: "width:20%;" },
  { key: "state", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../shared/datatable/Table.vue";
import CModalForm from "../shared/modals/cModalForm.vue";
import cModalDelete from "../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import { bus } from "../../main";
import { CSwitch } from "@coreui/vue-pro";
import CSwitchVue from "../shared/switch/CSwitch.vue";
// import cSelect from "../shared/inputs/cSelect.vue";
import cSelectForm from "../../components/shared/inputs/cSelect.vue";


export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue, cSelectForm },
  data() {
    return {
      prefix: "employees",
      fields,
      data: [],
      data_companies: [],
      data_roles: [],


      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      employee: {
        id: "",
        company_id: this.$store.getters.get_all_user.id == 1 ? "" : this.$store.getters.get_company.id,
        company_reason_social: "",
        rol_id: "",
        rol_name: "",
        name: "",
        last_name: "",
        dni: "",
        address: "",
        phone: "",
        email: "",
        campu_id: this.$store.getters.get_all_user.id == 1 ? "" : this.$store.getters.get_campu.value,
        admin_rol_id: this.$store.getters.get_all_user.roles[0].role_id,
        state: 0,
      },

      errors: {
        phone: "",
        dni: "",
        email_employee:"",
        name:"",
        last_name:"",
      },
      modal_delete: {
        boo: false,
        item: [],
      },

      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      // dataStore: [],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.employee.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.employee.name != "" &&
        this.employee.address != "" &&
        this.employee.dni != "" &&
        this.employee.company_id != "" &&
        this.employee.rol_id != "" &&
        this.employee.phone != "" &&
        this.employee.email !== "" &&
        this.errors.email_employee == "" &&
        this.errors.name == "" &&
        this.errors.phone == "" &&
        this.errors.dni == "") return false;
      return true;
    },
    initialCompanyId() {
      return this.$store.getters.get_all_user.id === 1 ? "" : this.$store.getters.get_company.id;
    },
  },
  created() {
    this.employee.company_id = this.initialCompanyId;
    this.mtd_getdata();
    this.indexCampus();
    this.indexRoles();
  },
  methods: {
    ...mapActions(["get", "post"]),
    indexCampus: function () {
      this.get({
        url: this.$store.getters.get__url + "/employees/1",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          response.data.forEach((element) => {
            this.data_companies.push({
              label: element.reason_social,
              value: element.id,
            });
          });
        })
        .catch((errors) => { });
    },
    indexRoles: function () {
      this.get({
        url: this.$store.getters.get__url + "/employees/role/1",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          if (this.$store.getters.get_all_user.id === 1) {
            response.data.forEach((element) => {
              if (![5].includes(element.id)) {
                this.data_roles.push({
                  label: element.name,
                  value: element.id,
                });
              }
            });
          } else {
            response.data.forEach((element) => {
              if (![1, 5].includes(element.id)) { // Filter out roles with IDs 1 and 5
                this.data_roles.push({
                  label: element.name,
                  value: element.id,
                });
              }
            });
          }

        })
        .catch((errors) => { });
    },
    mtd_getdata: function () {
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix + "/index/" + this.$store.getters.get_all_user.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.employees;
          let index = 1;
          this.data.forEach((arr) => {
            arr.index = index;
            index++;
          })
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Trabajador")
        : (this.modal.title = "Editar Trabajador");
      if(action == "store"){
        this.employee = {
          id: "",
          company_id: this.initialCompanyId,
          rol_id: "",
          rol_name: "",
          name: "",
          last_name: "",
          dni: "",
          address: "",
          phone: "",
          email: "",
          campu_id: this.$store.getters.get_all_user.id == 1 ? "" : this.$store.getters.get_campu.value,
          admin_rol_id: this.$store.getters.get_all_user.roles[0].role_id,
          state: "",
        };
        this.errors = {
          phone: "",
          dni: "",
          name: "",
          email_employee:"",
        };
      }else{
        this.employee = { ...this.employee }; 
        this.errors = {
          phone: "",
          dni: "",
          name: "",
          email_employee:"",
        };
      }
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      if (!this.validateForm()) return;

      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.employee,
      })
        .then((response) => {
          if (response.data.state == 1) {
            Swal.fire({
              title: "Dni ya resgistrado",
              icon: "warning"
            });
          } else {
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedEmployee = response.data.data;
              let index = this.data.findIndex(employee => employee.id === updatedEmployee.id);
              if (index !== -1) {
                this.$set(this.data, index, updatedEmployee);
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };

            this.employee = {
              id: "",
              company_id: this.initialCompanyId,
              rol_id: "",
              rol_name: "",
              name: "",
              last_name: "",
              dni: "",
              address: "",
              phone: "",
              email: "",
              state: "",
            }
            bus.$emit("alert", {
              color: color,
              message: message,
            });
          }
        })
        .catch((errors) => {
          bus.$emit("alert", {
            color: "danger",
            message: errors,
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.employee = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => { });
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.id,
        },
      })
        .then((response) => {
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };

          bus.$emit("alert", {
            color: "success",
            message: "ELIMINADO CORRECTAMENTE",
          });
        })
        .catch((errors) => { });
    },
    ValidateName() {
      const regex = /^[A-Za-z\s]+$/;
      if (!regex.test(this.employee.name)) {
        this.errors.name = "El nombre solo puede contener letras";
      } else {
        this.errors.name = "";
      }
    },
    ValidateLastName() {
      const regex = /^[A-Za-z\s]+$/;
      if (!regex.test(this.employee.last_name)) {
        this.errors.last_name = "El apellido solo puede contener letras"
      }else {
        this.errors.last_name = "";
      }
    },
    validatePhone() {
      if (this.employee.phone.length != 9 || isNaN(this.employee.phone)) {
        this.errors.phone = "El teléfono debe ser un número de máximo 9 dígitos";
      } else {
        this.errors.phone = "";
      }
    },
    validateDNI() {
      if (this.employee.dni.length != 8 || isNaN(this.employee.dni)) {
        this.errors.dni = "El DNI debe ser un número de máximo 8 dígitos";
      } else {
        this.errors.dni = "";
      }
    },
    validateEmail(email) {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
          this.errors.email_employee =
            "El correo electrónico no tiene un formato válido";
        } else {
          this.errors.email_employee = "";
        }
    },
    validateForm() {
      this.validateDNI();
      this.validatePhone();
      this.validateEmail(this.employee.email);
      return (
        this.errors.dni === "" &&
        this.errors.phone === "" &&
        this.errors.email_employee === ""
      );
    },
    changeSwitch: function (payload) {
      this.employee.state = payload == true ? 1 : 0;
    },
  },
  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
